import React from 'react';
import PropTypes from 'prop-types';

// Mixins / Modules
import { isEmptyObject } from '../../../../../../modules/global';

// Base
import HeaderBar from '../../../../base/header_bar';

export default class Role extends React.Component {
  static propTypes = {
    persona: PropTypes.object.isRequired,
  }

  get personaSelected() {
    const { persona } = this.props;
    return !isEmptyObject(persona);
  }

  render() {
    const { persona } = this.props;

    return (
      <React.Fragment>
        {
          this.personaSelected &&
          <HeaderBar {...{
            text: persona.name || 'Default',
          }} />
        }
      </React.Fragment>
    )
  }
}